import { MediaOrientation } from '../../types';
const SQUARE_THRESHOLD = 100;
export const calculateOrientation = _ref => {
  let {
    width,
    height
  } = _ref;
  const heightWidthDiff = height - width;
  switch (true) {
    case Math.abs(heightWidthDiff) <= SQUARE_THRESHOLD:
      return MediaOrientation.Square;
    case heightWidthDiff > 0:
      return MediaOrientation.Portrait;
    case heightWidthDiff < 0:
      return MediaOrientation.Landscape;
    default:
      return null;
  }
};
export const getImageMetadata = async imageUrl => {
  return new Promise((resolve, _reject) => {
    const script = new Image();
    script.addEventListener('load', () => {
      const {
        naturalWidth,
        naturalHeight
      } = script;
      document.head.removeChild(script);
      resolve({
        dimensions: {
          height: naturalHeight,
          width: naturalWidth
        }
      });
    });
    script.src = imageUrl;
    document.head.appendChild(script);
  });
};
//# sourceMappingURL=image-size.js.map